// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"HamburgerMenuOpener_wrapper__vg3CY","line":"HamburgerMenuOpener_line__TU5cM"};